import { Select } from "antd";
import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";
import { useTenantWebTypeSelectOptions } from "components/UI/Selects/TenantWebTypeSelectSearchable/useTenantWebTypeSelectOptions.ts";

export const TenantWebTypeSelectSearchable = (props: SearchableSelectWrapperProps) => {
    const hookResult = useTenantWebTypeSelectOptions();

    if (hookResult.loading && !hookResult.options.length) {
        return <Select {...props} loading disabled size={props.size ?? "middle"} />;
    }

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.tenant_web_type"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
